<!-- 设置用户权限 -->
<template>
	<div>
		<el-dialog id="qx" :visible.sync="dataActionBox.showStatus" title="设置用户权限"  append-to-body center :close-on-click-modal="false"  width="80%" top="1rem">
			<el-form ref="form"  label-position="top" label-width="120px" size="mini">
				<el-form-item label="权限模板">
					<el-select v-model="templateInfo" clearable placeholder="选择模板" style="width: 100%;">
                        <el-option value="wu" label="无"></el-option>
					    <el-option v-for="(tempValue,tempKey) in dataList"  :key="tempKey"  :label="tempValue.jteName" :value="tempKey">
					    </el-option>
					</el-select>
				</el-form-item>
				<el-tree ref="menuTree" :data="menuList" :props="{ label: 'label', children: 'children' }" 
				 @check="handleCheckChange" check-strictly node-key="jurId"
				 show-checkbox></el-tree>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="saveUserJurisdiction()">保存</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'settingUserJurisdiction',
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				openMode:'ltr'||'rtl',
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			filterText: '',
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			menuList:[],
			
			// 用户新权限
			userJurisdiction:[],
			dataList:[],
			userInfo:{},
			
			templateInfo:"",
            userJurisdictionDefault: {},
			activeName: '',
			tabIndex: 0,
			nodeData: [],
			roleToMenuList:[]
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
		"templateInfo":{
			handler:function(newValue,oldValue){
				console.log(newValue)
				if(newValue>=0){
					var info = this.dataList[this.templateInfo]
					console.log(info)
					this.userJurisdiction = info.jurtemre
					this.$nextTick(()=>{
					this.menuList.forEach((item,index)=>{
						this.$refs.menuTree.setCheckedKeys(this.userJurisdiction)
					})
				})
				} else if (newValue == 'wu') {
					this.userJurisdiction = this.userJurisdictionDefault
					this.$nextTick(()=>{
					this.menuList.forEach((item,index)=>{
						this.$refs.menuTree.setCheckedKeys(this.userJurisdiction)
					})
				})
                }
			},
			deep:true,
		},
		"tabIndex":{
			handler:function(newValue,oldValue){
				this.nodeData[oldValue] = this.$refs.menuTree[oldValue].getCheckedNodes()
					// this.$refs.menuTree[index].setCheckedKeys(sendDataInfo)
			},
			deep:true,
		}
	},
    //方法集合
    methods: {
		menuCheckChange(){},
		// tree 发生点击 变化时
		// 统一处理子节点为相同的勾选状态
		uniteChildSame(treeList, isSelected) {
			if (isSelected) {
				this.userJurisdiction.push(treeList.jurId)
			} else {
				this.userJurisdiction.forEach((item,index)=>{
					if (item == treeList.jurId) {
						this.userJurisdiction.splice(index,1)
					}
				})
			}
			this.$refs.menuTree.setChecked(treeList.jurId, isSelected);
			if (!treeList.children) return
			for (let i = 0; i < treeList.children.length; i++) {
				this.uniteChildSame(treeList.children[i], isSelected);
			}
		},
		// 统一处理父节点为选中
		selectedParent(currentObj) {
			let currentNode = this.$refs.menuTree.getNode(currentObj);
			if (currentNode.parent.key !== undefined) {
				if (!this.userJurisdiction.includes(currentNode.parent.data.jurId)) this.userJurisdiction.push(currentNode.parent.data.jurId)
				this.$refs.menuTree.setChecked(currentNode.parent, true);
				this.selectedParent(currentNode.parent);
			}
		},
		handleCheckChange(currentObj, treeStatus) {
			console.log(currentObj, treeStatus)
			this.$refs.menuTree.getCheckedNodes()
			// 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联。
			let selected = treeStatus.checkedKeys.indexOf(currentObj.jurId); // -1未选中,>=0为选中
			// 选中
			if (selected !== -1) {
				// 子节点只要被选中父节点就被选中(需要选中父节点时候调用此方法)
				this.selectedParent(currentObj);
				// 统一处理子节点为相同的勾选状态
				this.uniteChildSame(currentObj, true);
			} else {
				this.userJurisdiction.forEach((item,index)=>{
					if (item == currentObj.jurId) {
						this.userJurisdiction.splice(index,1)
					}
				})
				// 未选中 处理子节点全部未选中
				if (!currentObj.children) return
				if (currentObj.children.length !== 0) {
					this.uniteChildSame(currentObj, false);
				}
			}
		},
		handleClick(tab, event) {
			this.tabIndex = Number(tab.index)
			this.$refs.menuTree.setCheckedKeys(this.userJurisdiction)
      	},
		handleCheckAllChange(levOne,levTwo){
			
		},
		// 获取权限
		async getJurisdictionList(){
			let responseData =  await this.$http.getJurisdictionList({jurType: 0})  //权限类型权限类型0.erp1.协同
			if(responseData.status == 200){
				this.menuList = this.handleJurisdiction(responseData.result)
				console.log('this.menuList',this.menuList)
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
			
		},
			
		// 获取用户权限
		async getUserJurisdiction(opmId){
			
			let responseData =  await this.$http.getUserJurisdiction({
                jurType: 0, //	权限类型权限类型0.erp1.协同
                opmId: opmId, //	id列表
            })
			if(responseData && responseData.status && responseData.status == 200){
				this.jurisdictionSettingBox = true
				var selectedList = []
				console.log('用户权限',responseData.result)
				responseData.result.forEach(item=>{
					selectedList.push(item.jurId)
				})
                this.userJurisdictionDefault = selectedList
				this.userJurisdiction = selectedList
				this.$nextTick(()=>{
					console.log(this.$refs.menuTree)
					// this.menuList.forEach((item,index)=>{
						this.$refs.menuTree.setCheckedKeys([])
						this.$refs.menuTree.setCheckedKeys(this.userJurisdiction)
					// })
				})
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
		// 保存人员权限
		async saveUserJurisdiction(){
			var sendDataInfo = []
			// let res = []
			// this.menuList.forEach((item, index) => {
			// 	res = res.concat(this.$refs.menuTree[index].getCheckedNodes())
			// })
			this.userJurisdiction = [...new Set(this.userJurisdiction)]
			this.userJurisdiction.forEach((key, i) => {
				sendDataInfo.push(
					{
						jurId: key,
						opmId: this.userInfo.opmId,
						jteId: this.templateInfo?this.dataList[this.templateInfo].jteId:"",
					}
				)
			})
			// this.userJurisdiction.forEach(itme=>{
			// 	sendDataInfo.push({
			// 		jurId:itme,
			// 		opmId:this.userInfo.opmId,
			// 	})
				
			// })
			// console.log(this.userJurisdiction)
			console.log(this.dataList[this.templateInfo],sendDataInfo,'sendDataInfo1111111')
			// return false
			let responseData =  await this.$http.saveUserJurisdiction(sendDataInfo)
			if(responseData.status == 200){
				this.$message({
					message: '保存成功',
					type: 'success'
				});
				this.dataActionBox.showStatus =  false
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
			
		},
		
	
		
		
		// 权限处理
		handleJurisdiction(data , id = 0 , lev = 0) {
		    var son = []
			data.forEach((value,keys)=>{
				value['selectedStatus'] = false
				this.userJurisdiction.forEach((userValue,userKeys)=>{
					if(value['jurId'] == userValue['jurId']){
						value['selectedStatus'] = true
					}
				})
				if(value['jurParentid'] == id) {
					// if(value['jurId'] == this.sendDataInfo.jurId){
					// 	value['disabled'] = true;
					// }
					value['id'] = value['jurId']
					value['value'] = value['jurId']
					value['label'] = value['jurName']
					
					var list = this.handleJurisdiction(data ,value['jurId'] , lev+1);
					if(list.length>=1){
						value['children'] = this.handleJurisdiction(data ,value['jurId'] , lev+1);
					}
					son.push(value)
					
				}
			})
		    return son;
		},
		
		
		

		
		openBox(oldData=''){
			this.userInfo = oldData
			this.getUserJurisdiction(oldData.opmId)
			this.userJurisdiction = []
			this.dataActionBox.showStatus = true
		},
		
		// 获取模板
		async getDataList(){
			let responseData =  await this.$http.getJurisdictionTemplate()
			if(responseData && responseData.status == 200){
				this.dataList = responseData.result
				console.log(9999999999999999999999999999,this.dataList);
				this.selectedDataIndex = 0
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
			
		},
		
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
		this.getJurisdictionList()
		this.getDataList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.el-cascader .el-cascader__tags{
	max-height: 300px !important;
	overflow-y: scroll !important;
}
.jurisdiction_box_one{
	padding: 1rem;
}
.jurisdiction_one{
	width: 100%;
	margin-bottom: .2rem;
}
.jurisdiction_three_box{
	padding:  .5rem 0;
}
#qx .el-tabs__header{
    height: auto !important;
}
</style>